<template>
  <section v-if="loading || error || state.available || state.enabled || codes.length" class="account-security profile-section card">
    <h4>Verificación en dos pasos</h4>
    <p v-if="loading" role="status">Cargando seguridad…</p>
    <template v-else>
      <template v-if="codes.length">
        <h5>Guarde sus códigos de recuperación</h5>
        <p>Solo se muestran ahora. Cada código sirve una vez para acceder o desactivar la verificación si no puede recibir mensajes. Guárdelos fuera de esta cuenta.</p>
        <pre>{{ codes.join('\n') }}</pre>
        <button type="button" @click="download">Descargar códigos</button>
        <label><input v-model="saved" type="checkbox"> He guardado los códigos en un lugar seguro.</label>
        <button type="button" :disabled="!saved" @click="codes = []">Continuar</button>
      </template>
      <TwoFactorChallenge v-else-if="state.pending && state.pending.purpose !== 'login'" :pending="state.pending" @verified="verified" @cancelled="load" />
      <form v-else @submit.prevent="start">
        <p v-if="state.enabled">Activada por {{ state.channel === 'sms' ? 'SMS' : 'email' }} a {{ state.destination }}. Códigos de recuperación restantes: {{ state.recovery_remaining }}.</p>
        <p v-else>Opcional. Al activarla, además de su contraseña necesitará un código en cada nuevo inicio de sesión.</p>
        <template v-if="!state.enabled">
          <label for="security-channel">Recibir el código por</label>
          <select id="security-channel" v-model="channel" :disabled="busy"><option value="email">Email de mi cuenta</option><option value="sms">SMS</option></select>
          <label v-if="channel === 'sms'" for="security-phone">Móvil con prefijo internacional</label>
          <input v-if="channel === 'sms'" id="security-phone" v-model="phone" type="tel" autocomplete="tel" placeholder="+34600111222" required :disabled="busy">
          <p>La protección solo se activa después de confirmar un código recibido en el canal elegido. Email y SMS no protegen frente a todas las formas de suplantación.</p>
        </template>
        <label for="security-password">Contraseña actual</label>
        <input id="security-password" v-model="password" type="password" autocomplete="current-password" required :disabled="busy">
        <button type="submit" :disabled="busy">{{ busy ? 'Procesando…' : state.enabled ? 'Verificar para desactivar' : 'Preparar activación' }}</button>
        <p v-if="state.enabled">Para cambiar de canal, desactive primero verificando su identidad y vuelva a activarlo.</p>
      </form>
    </template>
    <p v-if="error" role="alert">{{ error }} <button type="button" @click="load">Consultar estado</button></p>
  </section>
</template>
<script>
import TwoFactorChallenge from './TwoFactorChallenge.vue';
import { twoFactorRepository } from '../api/twoFactorRepository';
export default {
  components: { TwoFactorChallenge },
  data: () => ({ state: {}, loading: true, error: '', busy: false, channel: 'email', phone: '', password: '', codes: [], saved: false }),
  mounted() { this.load(); },
  beforeDestroy() { this.password = ''; this.codes = []; },
  methods: {
    async load() {
      this.loading = true; this.error = '';
      try { this.state = await twoFactorRepository.session(); }
      catch (e) { this.error = e.message; }
      finally { this.loading = false; }
    },
    async start() {
      this.busy = true; this.error = '';
      try { this.state = await twoFactorRepository.post(this.state.enabled ? 'disable' : 'enroll', { password: this.password, channel: this.channel, phone: this.phone }); }
      catch (e) { this.error = e.message; }
      finally { this.password = ''; this.busy = false; }
    },
    async verified(result) { this.codes = result.recovery_codes || []; this.saved = false; await this.load(); },
    download() {
      const url = URL.createObjectURL(new Blob(['Códigos de recuperación Eurekers (un solo uso)\n\n' + this.codes.join('\n')], { type: 'text/plain' }));
      const a = document.createElement('a'); a.href = url; a.download = 'eurekers-recuperacion.txt'; a.click(); setTimeout(() => URL.revokeObjectURL(url), 1000);
    }
  }
};
</script>
<style scoped>
.account-security { display: grid; gap: 12px; }
h4 { margin: 0; font-size: 1.05rem; font-weight: 600; }
p { margin: 0; color: var(--color-text-secondary, #626a7d); font-size: 14px; line-height: 1.6; }
label { font-size: 14px; }
form { display: grid; gap: 10px; max-width: 560px; }
input:not([type=checkbox]), select { min-height: 44px; padding: 10px; border: 1px solid var(--color-outline, #aab3c3); border-radius: 8px; width: 100%; box-sizing: border-box; background: var(--color-surface, white); color: inherit; }
button { padding: 10px 16px; min-height: 44px; border-radius: 8px; border: 1px solid var(--color-outline, #aab3c3); background: var(--primary, #008bab); color: white; cursor: pointer; }
button:disabled { opacity: .55; cursor: default; }
pre { white-space: pre-wrap; overflow-wrap: anywhere; padding: 16px; border: 1px solid var(--color-outline, #aab3c3); border-radius: 8px; }
[role=alert] { color: #b3261e; }
</style>
